/*
 * @Description: 
 * @version: 
 * @Author: 小六
 * @Date: 2022-04-06 11:33:31
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-26 12:02:52
 */
import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
// import Maps from '@/views/map'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [

    {
      path: '/',
      component: () => import('@/views/index'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js